import _, { map, first, get, merge } from 'lodash';
import { BO_URL } from '@/config/envConfig';
import { faLaptopHouse, faCubes } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { E_BEHAVIOR, E_ROUTE_MAILMANAGEMENT, E_ROUTE_OPEN_API_CONTENT_CONFIGURABLE, E_ROUTE_OPERATION_TOOLS, E_ROUTE_SYSTEM, E_ROUTE_TROUBLESHOOTING, PRODUCT_DATA_STATISTICS, E_ROUTE_ADMIN, E_ROUTE_OPEN_API_INNO_API, E_ROUTE_NOTICE_CENTER, E_DATA_PROTECTION, } from '@/router/routes/route.types';
import { IsAdmin } from '@/@core/environment';
import AppFeature from '@/store/app-feature';
library.add(faLaptopHouse, faCubes);
export var E_Layout;
(function (E_Layout) {
    E_Layout["horizontal"] = "horizontal";
    E_Layout["vertical"] = "vertical";
})(E_Layout || (E_Layout = {}));
// 递归过滤无权限数据
function removeBlockedMenu(menus, $P) {
    return _.flatMap(menus, menu => {
        if (_.isBoolean(menu.enable) && !menu.enable) {
            return [];
        }
        if (!menu.permission || $P(menu.permission)) {
            const children = removeBlockedMenu(menu.children, $P);
            if (children.length) {
                menu.route = children[0].route;
                menu.href = children[0].href;
            }
            if (children.length <= 1) {
                // 去掉children 属性
                return [_.omit(menu, 'children')];
            }
            else {
                return [{
                        ...menu,
                        children,
                    }];
            }
        }
        else {
            return [];
        }
    });
}
export function buildMenu(layout, $P) {
    let commonHeader = [];
    const ENABLE_SUPERSET = AppFeature.getters.Features(AppFeature.state).ENABLE_SUPERSET;
    const ENABLE_DASHBOARD = AppFeature.getters.Features(AppFeature.state).ENABLE_DASHBOARD;
    const ENABLE_SUPERSET_NEW_FEATURE = AppFeature.getters.Features(AppFeature.state).ENABLE_SUPERSET_NEW_FEATURE;
    const ENABLE_OPEN_API = AppFeature.getters.Features(AppFeature.state).ENABLE_OPEN_API;
    const ENABLE_PROMPT_MANAGEMENT = AppFeature.getters.Features(AppFeature.state).ENABLE_PROMPT_MANAGEMENT;
    const ENABLE_EMAIL_TEMPLATE_MANAGEMENT = AppFeature.getters.Features(AppFeature.state).ENABLE_EMAIL_TEMPLATE_MANAGEMENT;
    const ENABLE_ORGANIZATION_MANAGEMENT = AppFeature.getters.Features(AppFeature.state).ENABLE_ORGANIZATION_MANAGEMENT;
    const ENABLE_LAB = AppFeature.getters.Features(AppFeature.state).ENABLE_LAB;
    const ENABLE_ABTEST = AppFeature.getters.Features(AppFeature.state).ENABLE_ABTEST;
    const SUPERSET_EMAIL = AppFeature.getters.Features(AppFeature.state).SUPERSET_EMAIL;
    const SUPERSET_NOTIFICATION_CENTER = AppFeature.getters.Features(AppFeature.state).SUPERSET_NOTIFICATION_CENTER;
    const SUPERSET_NEW_FEATURE = AppFeature.getters.Features(AppFeature.state).SUPERSET_NEW_FEATURE;
    if (!IsAdmin) {
        commonHeader = [
            {
                permission: 'Dashboard',
                enable: ENABLE_DASHBOARD,
                title: 'backoffice.nav.Home',
                icon: 'BarChart2Icon',
                route: E_BEHAVIOR.DashBoard,
            },
            {
                title: 'backoffice.nav.company_man',
                faIcon: 'laptop-house',
                permission: 'Company',
                children: [
                    {
                        title: 'backoffice.nav.company_man',
                        faIcon: 'laptop-house',
                        route: 'companies',
                        permission: 'CompanyList',
                    },
                    {
                        title: 'backoffice.nav.whitelist',
                        icon: 'BookIcon',
                        route: 'cooperative-company-list',
                        permission: 'CooperativeCompanies',
                    }
                ],
            },
            {
                permission: 'Account',
                title: 'backoffice.nav.account',
                icon: 'UsersIcon',
                route: 'accounts',
            },
            {
                permission: 'PackagesMenu',
                title: 'backoffice.nav.package',
                faIcon: 'cubes',
                children: [
                    {
                        permission: 'Packages',
                        title: 'backoffice.nav.package',
                        faIcon: 'cubes',
                        route: 'package',
                    },
                    {
                        permission: 'Capacity',
                        title: 'backoffice.nav.custom_capacity',
                        icon: 'ShoppingBagIcon',
                        route: 'capacity',
                    },
                    {
                        permission: 'Service',
                        title: 'backoffice.nav.product_function',
                        icon: 'ServerIcon',
                        route: 'feature',
                    }
                    // {
                    //     permission: 'Service',
                    //     title: 'backoffice.nav.standary_capacity',
                    //     icon: 'ServerIcon',
                    //     route: 'service',
                    // },
                    // {
                    //     permission: 'Resource',
                    //     title: 'backoffice.nav.resource',
                    //     icon: 'CodepenIcon',
                    //     route: 'resource',
                    // }
                ],
            },
            {
                permission: 'Troubleshooting',
                // title: 'backoffice.nav.Troubleshooting',
                title: 'backoffice.nav.informationManagement',
                faIcon: 'bomb',
                children: [
                    {
                        permission: 'Notifications',
                        title: 'backoffice.nav.notifications',
                        icon: 'BellIcon',
                        children: [
                            {
                                permission: 'PostNotificationUserMessageList',
                                title: 'backoffice.nav.notificationDetail',
                                icon: 'InboxIcon',
                                route: E_ROUTE_NOTICE_CENTER.NOTICE_DETAIL,
                            },
                            {
                                permission: 'PostNotificationScenesList',
                                title: 'backoffice.nav.notificationConfiguration',
                                icon: 'SettingsIcon',
                                route: E_ROUTE_NOTICE_CENTER.NOTICE_CONFIGURATION,
                            },
                            {
                                permission: 'SuperSet',
                                target: '_self',
                                title: 'backoffice.nav.data_analysis',
                                icon: 'BarChart2Icon',
                                href: `/#/ProductDataStatistics/notice-center/${SUPERSET_NOTIFICATION_CENTER}`,
                            }
                        ],
                    },
                    // add mail module:
                    {
                        permission: 'Mail',
                        title: 'backoffice.nav.Mail',
                        icon: 'MailIcon',
                        children: [
                            {
                                permission: 'MailConfigList',
                                route: E_ROUTE_MAILMANAGEMENT.SETTING,
                                title: 'backoffice.Mail.setting',
                                icon: 'SettingsIcon',
                            },
                            {
                                permission: 'MailSendList',
                                route: E_ROUTE_MAILMANAGEMENT.SEND,
                                title: 'backoffice.Mail.send',
                                icon: 'SendIcon',
                            },
                            // {
                            //     permission: 'MailRecepitList',
                            //     route: E_ROUTE_MAILMANAGEMENT.RECEIPT,
                            //     title: 'backoffice.Mail.receipt',
                            //     icon: 'RepeatIcon',
                            // },
                            {
                                permission: 'MailUnreachableGetList',
                                route: E_ROUTE_MAILMANAGEMENT.UNREACHABLE,
                                title: 'backoffice.Mail.unreachable',
                                icon: 'UserXIcon',
                            },
                            {
                                permission: 'SuperSet',
                                href: `/#/ProductDataStatistics/mail/${SUPERSET_EMAIL}`,
                                target: '_self',
                                title: 'backoffice.nav.data_analysis',
                                icon: 'BarChart2Icon',
                            }
                        ],
                    },
                    // add messagesend module:
                    {
                        permission: 'MessageSend',
                        route: E_ROUTE_TROUBLESHOOTING.TROUBLESHOOTING_MESSAGESEND,
                        title: 'backoffice.nav.MessageSend',
                        faIcon: ['far', 'paper-plane'],
                    },
                    {
                        permission: 'SessionManagement',
                        route: E_ROUTE_TROUBLESHOOTING.SESSSION_MANAGER,
                        title: 'backoffice.nav.SessionManagement',
                        icon: 'MessageSquareIcon',
                    },
                    {
                        permission: 'SessionKickoutauditrecordsGetList',
                        route: E_ROUTE_TROUBLESHOOTING.TROUBLESHOOTING_KICKOUT,
                        title: 'backoffice.nav.Kickout',
                        faIcon: 'sign-out-alt',
                    }
                ],
            },
            {
                permission: 'OperationTool',
                title: 'backoffice.nav.operation_tool',
                icon: 'ToolIcon',
                children: [
                    {
                        // $t('backoffice.nav.productResourceSpaceManagement')
                        permission: 'OperationManagement',
                        title: 'backoffice.nav.operationManagement',
                        icon: 'LayoutIcon',
                        children: [
                            {
                                permission: 'ProductResourceSpaceManagement',
                                title: 'backoffice.nav.productResourceSpaceManagement',
                                icon: 'SettingsIcon',
                                route: E_ROUTE_OPERATION_TOOLS.PRODUCT_RESOURCE_SPACE_MANAGEMENT,
                            },
                            {
                                permission: 'PqlRuleManagement',
                                title: 'backoffice.nav.ruleManagement',
                                icon: 'GitPullRequestIcon',
                                route: E_ROUTE_OPERATION_TOOLS.OPERATION_PQL_RULE_MANAGEMENT,
                            }
                        ],
                    },
                    {
                        permission: 'PatsnapLab',
                        title: 'Patsnap Lab',
                        icon: 'ArchiveIcon',
                        route: 'patsnap-lab',
                        enable: ENABLE_LAB,
                    },
                    {
                        permission: 'workspace',
                        title: 'backoffice.nav.workspace',
                        icon: 'FolderIcon',
                        children: [
                            {
                                permission: 'TaskCenter',
                                title: 'backoffice.nav.task_center',
                                icon: 'FolderIcon',
                                route: 'workspace',
                            },
                            {
                                permission: 'DataMigration',
                                title: 'backoffice.nav.data_migration',
                                faIcon: 'folder-open',
                                route: 'data-migration',
                            },
                            {
                                // permission: 'DataAnalysis',
                                title: 'backoffice.nav.data_analysis',
                                icon: 'PieChartIcon',
                                route: 'data-analysis',
                            },
                            {
                                // permission: 'SeparateData',
                                title: 'backoffice.nav.separate_data',
                                icon: 'ColumnsIcon',
                                route: 'separateData',
                            }
                        ],
                    },
                    {
                        permission: 'NavigationLibrary',
                        title: 'backoffice.nav.navigation_library',
                        icon: 'CloudIcon',
                        route: 'navigation-library',
                        children: [
                            {
                                permission: 'NavigationLibraryAudit',
                                title: 'backoffice.nav.navigation_library_audit',
                                icon: 'EditIcon',
                                route: 'navigation-library-audit',
                            },
                            {
                                permission: 'AgencyList',
                                title: 'backoffice.nav.agency_list',
                                icon: 'ListIcon',
                                route: 'navigation-library-agency',
                            },
                            {
                                permission: 'NavigationLibraryOperation',
                                title: 'backoffice.nav.navigation_operation',
                                icon: 'BarChart2Icon',
                                route: 'navigation-library-operation',
                            }
                        ],
                    },
                    {
                        permission: 'SelfRegisterLink',
                        title: 'backoffice.nav.selfRegistionLink',
                        icon: 'SlackIcon',
                        children: [
                            // {
                            //     permission: 'EurekaInvitationManager',
                            //     title: 'backoffice.nav.eureka',
                            //     route: 'eureka',
                            //     icon: 'TargetIcon',
                            // },
                            {
                                permission: 'ActivityPromotionVisible',
                                title: 'backoffice.operationPromotionLink.operationPromotionSelfRegisterLink',
                                route: E_ROUTE_OPERATION_TOOLS.OPERATION_PROMOTION_LINL,
                                icon: 'Link2Icon',
                            },
                            {
                                permission: 'ApplyTrial',
                                title: 'backoffice.nav.systemLimit',
                                icon: 'ArchiveIcon',
                                route: 'applyTrial',
                            }
                        ],
                    },
                    {
                        permission: 'RecommendationManagement',
                        title: 'backoffice.nav.recommendation_management',
                        icon: 'SettingsIcon',
                        route: 'recommendation-management',
                    },
                    {
                        permission: 'OpenApi',
                        title: 'backoffice.nav.open_api',
                        icon: 'CodeIcon',
                        route: 'openApi',
                        enable: ENABLE_OPEN_API,
                        children: [
                            {
                                permission: 'MenuClassification',
                                title: 'backoffice.nav.open_api_menu',
                                icon: 'AlignRightIcon',
                                route: 'openApiMenu',
                            },
                            {
                                permission: 'ApiConfig',
                                title: 'backoffice.nav.open_api_maintain',
                                icon: 'ToolIcon',
                                route: 'openApiApiMaintain',
                            },
                            {
                                permission: 'ApiConfig',
                                title: 'backoffice.nav.open_api_file_maintain',
                                icon: 'ToolIcon',
                                route: 'openApiApiFileMaintain',
                            },
                            {
                                permission: 'ApiWhitelist',
                                title: 'backoffice.nav.open_api_whitelist',
                                icon: 'FileTextIcon',
                                route: 'openApiApiWhitelist',
                            },
                            {
                                permission: 'ProductPackageManagement',
                                title: 'backoffice.nav.open_api_package',
                                faIcon: 'cubes',
                                route: 'openApiApiPackage',
                            },
                            // 套餐额度分配：
                            {
                                permission: 'ProductPackageManagement',
                                title: 'backoffice.nav.open_api_quota_distribution',
                                faIcon: 'cubes',
                                route: 'openApiApiQuotaDistribution',
                            },
                            {
                                permission: 'ContentConfigurable',
                                title: 'backoffice.nav.open_api_content_configurable',
                                icon: 'ToolIcon',
                                route: E_ROUTE_OPEN_API_CONTENT_CONFIGURABLE.OPENAPI_CONTENT_CONFIGURABLE,
                            },
                            // INNO API key管理
                            {
                                permission: 'Analysis',
                                title: 'backoffice.nav.open_api_key_management',
                                faIcon: 'key',
                                route: E_ROUTE_OPEN_API_INNO_API.OPENAPI_INNO_API,
                            }
                        ],
                    },
                    {
                        permission: 'OpenPlatform',
                        title: 'backoffice.nav.OpenApi',
                        faIcon: 'window-restore',
                        children: [
                            {
                                permission: 'ApiAnalysis',
                                href: `${BO_URL}/backoffice/#/open-api/analysis`,
                                title: 'backoffice.nav.APIAnalysis',
                                faIcon: 'laptop-code',
                            },
                            {
                                permission: 'ProductClient',
                                href: `${BO_URL}/backoffice/#/open-api/client`,
                                title: 'backoffice.nav.ProductClient',
                                faIcon: ['far', 'window-maximize'],
                            },
                            {
                                permission: 'ProductBundle',
                                href: `${BO_URL}/backoffice/#/open-api/bundle`,
                                title: 'backoffice.nav.ProductBundle',
                                faIcon: 'cubes',
                            },
                            {
                                permission: 'ProductClientBundle',
                                href: `${BO_URL}/backoffice/#/open-api/client-bundle`,
                                title: 'backoffice.nav.ProductClientBundle',
                                faIcon: 'cubes',
                            },
                            {
                                permission: 'GatewayManagement',
                                href: `${BO_URL}/backoffice/#/open-api/gateway-management`,
                                title: 'backoffice.nav.GatewayManagement',
                                faIcon: 'network-wired',
                            }
                        ],
                    },
                    {
                        permission: 'DataProtection',
                        title: 'backoffice.nav.data_protection',
                        icon: 'CodeIcon',
                        route: 'dataProtection',
                        children: [
                            {
                                permission: 'ExportManagement',
                                route: 'exportManagement',
                                title: 'backoffice.nav.export_management',
                                icon: 'AlignRightIcon',
                            },
                            {
                                permission: 'RestrictionList',
                                route: 'restrictionList',
                                title: 'backoffice.nav.restriction_list',
                                icon: 'BookOpenIcon',
                            },
                            {
                                permission: 'WhiteList',
                                route: 'whitelistManagement',
                                title: 'backoffice.nav.whitelist_management',
                                icon: 'FileTextIcon',
                            },
                            {
                                permission: 'UserRestrictedQuery',
                                route: 'userRestrictedQuery',
                                title: 'backoffice.nav.user_restricted_query',
                                icon: 'SearchIcon',
                            },
                            {
                                permission: 'CompanyTree',
                                title: 'backoffice.nav.company_tree',
                                icon: 'BarChart2Icon',
                                route: 'CompanyTree',
                            },
                            {
                                permission: 'IllegalManagement',
                                title: 'backoffice.illegal.illegal_management',
                                icon: 'BarChart2Icon',
                                route: E_DATA_PROTECTION.ILLEGAL_MANAGEMENT,
                            }
                        ],
                    },
                    {
                        permission: 'ReleasePlan',
                        title: 'backoffice.nav.release_plan',
                        icon: 'AlignRightIcon',
                        route: 'ReleasePlan',
                    },
                    {
                        permission: 'AbTestManagement',
                        title: 'backoffice.nav.abtest',
                        faIcon: 'laptop-house',
                        route: 'AbTest',
                        enable: ENABLE_ABTEST,
                    },
                    {
                        permission: 'PromptManagement',
                        title: 'backoffice.nav.promptManagement',
                        icon: 'AtSignIcon',
                        route: 'PromptManagementHome',
                        enable: ENABLE_PROMPT_MANAGEMENT,
                    },
                    {
                        permission: 'EmailTemplateManagement',
                        title: 'backoffice.nav.emailTemplateManagement',
                        icon: 'MailIcon',
                        route: 'EmailTemplateManagementHome',
                        enable: ENABLE_EMAIL_TEMPLATE_MANAGEMENT,
                    },
                    {
                        permission: 'OrganizationManagement',
                        title: 'department.title',
                        icon: 'CalendarIcon',
                        route: 'OrganizationManagementHome',
                        enable: ENABLE_ORGANIZATION_MANAGEMENT,
                    }
                ],
            },
            {
                permission: 'DeveloperTool',
                title: 'backoffice.nav.DeveloperTool',
                faIcon: 'laptop-code',
                children: [
                    {
                        permission: 'ProductManager',
                        title: 'backoffice.nav.Product',
                        icon: 'GridIcon',
                        children: [
                            {
                                permission: 'ProductRolesGetList',
                                title: 'backoffice.nav.ProductRole',
                                faIcon: ['far', 'id-badge'],
                                route: 'products-roles',
                            },
                            {
                                permission: 'ResourcesRoleLimitationGetList',
                                title: 'backoffice.nav.ProductRoleLimitation',
                                faIcon: ['far', 'address-book'],
                                route: 'products-limitation',
                            },
                            {
                                permission: 'ResourcesGetList',
                                title: 'backoffice.nav.ProductResource',
                                faIcon: 'server',
                                route: 'products-resource',
                            },
                            {
                                permission: 'ProductClientManager',
                                title: 'backoffice.nav.ProductClient',
                                faIcon: 'desktop',
                                route: 'productsClients',
                            }
                        ],
                    },
                    {
                        permission: 'SystemManager',
                        title: 'backoffice.nav.System',
                        icon: 'DatabaseIcon',
                        children: [
                            {
                                permission: 'SearchEngineManagement',
                                route: E_ROUTE_SYSTEM.SEARCH_ENGINE_MANAGEMENT,
                                title: 'backoffice.nav.SearchEngineManagement',
                                icon: 'SearchIcon',
                            },
                            {
                                permission: 'SamlConfigGetList',
                                route: E_ROUTE_SYSTEM.SYSTEM_SAML,
                                title: 'backoffice.nav.Saml',
                                faIcon: 'hard-hat',
                            }
                        ],
                    },
                    {
                        permission: 'CoreUtility',
                        title: 'backoffice.nav.coreUtility',
                        icon: 'ServerIcon',
                        route: 'core-utility',
                    }
                ],
            },
            {
                permission: 'SuperSet',
                enable: ENABLE_SUPERSET,
                title: 'backoffice.nav.DataAnalysis',
                icon: 'AirplayIcon',
                route: PRODUCT_DATA_STATISTICS.PRODUCT_DATA_STATISTICS,
                children: [{
                        permission: 'SuperSet',
                        route: PRODUCT_DATA_STATISTICS.PRODUCT_OVERVIEW,
                        title: 'backoffice.nav.dataStatistics.overview',
                        icon: 'ApertureIcon',
                    }, {
                        permission: 'SuperSet',
                        route: PRODUCT_DATA_STATISTICS.ANALYTICS,
                        title: 'backoffice.nav.dataStatistics.analytics',
                        icon: 'AtSignIcon',
                    },
                    {
                        permission: 'SuperSet',
                        route: PRODUCT_DATA_STATISTICS.EUREKA,
                        title: 'backoffice.nav.dataStatistics.eureka',
                        icon: 'BookOpenIcon',
                    },
                    {
                        permission: 'SuperSet',
                        route: PRODUCT_DATA_STATISTICS.WORKSPACE,
                        title: 'backoffice.nav.dataStatistics.workspace',
                        icon: 'CloudRainIcon',
                    },
                    {
                        permission: 'SuperSet',
                        route: PRODUCT_DATA_STATISTICS.BACKOFFICE,
                        title: 'backoffice.nav.dataStatistics.backoffice',
                        icon: 'CastIcon',
                    },
                    {
                        permission: 'SuperSet',
                        route: `${PRODUCT_DATA_STATISTICS.FEATURE}2026`,
                        title: 'backoffice.nav.dataStatistics.feature2026',
                        icon: 'CompassIcon',
                        enable: ENABLE_SUPERSET_NEW_FEATURE,
                        children: [{
                                permission: 'SuperSet',
                                href: `/#/ProductDataStatistics/features/2026/${SUPERSET_NEW_FEATURE[2026].Analytics}`,
                                target: '_self',
                                title: 'Analytics',
                            }, {
                                permission: 'SuperSet',
                                href: `/#/ProductDataStatistics/features/2026/${SUPERSET_NEW_FEATURE[2026].Eureka}`,
                                target: '_self',
                                title: 'Eureka',
                            }, {
                                permission: 'SuperSet',
                                href: `/#/ProductDataStatistics/features/2026/${SUPERSET_NEW_FEATURE[2026].BOP}`,
                                target: '_self',
                                title: 'BOP',
                            }],
                    },
                    {
                        permission: 'SuperSet',
                        route: `${PRODUCT_DATA_STATISTICS.FEATURE}2025`,
                        title: 'backoffice.nav.dataStatistics.feature2025',
                        icon: 'CompassIcon',
                        enable: ENABLE_SUPERSET_NEW_FEATURE,
                        children: [{
                                permission: 'SuperSet',
                                href: `/#/ProductDataStatistics/features/2025/${SUPERSET_NEW_FEATURE[2025].Analytics}`,
                                target: '_self',
                                title: 'Analytics',
                            }, {
                                permission: 'SuperSet',
                                href: `/#/ProductDataStatistics/features/2025/${SUPERSET_NEW_FEATURE[2025].Eureka}`,
                                target: '_self',
                                title: 'Eureka',
                            }, {
                                permission: 'SuperSet',
                                href: `/#/ProductDataStatistics/features/2025/${SUPERSET_NEW_FEATURE[2025].BOP}`,
                                target: '_self',
                                title: 'BOP',
                            }],
                    },
                    {
                        permission: 'SuperSet',
                        route: `${PRODUCT_DATA_STATISTICS.FEATURE}2024`,
                        title: 'backoffice.nav.dataStatistics.feature2024',
                        icon: 'CompassIcon',
                        enable: ENABLE_SUPERSET_NEW_FEATURE,
                        children: [{
                                permission: 'SuperSet',
                                href: `/#/ProductDataStatistics/features/2024/${SUPERSET_NEW_FEATURE[2024].Analytics}`,
                                target: '_self',
                                title: 'Analytics',
                            }, {
                                permission: 'SuperSet',
                                href: `/#/ProductDataStatistics/features/2024/${SUPERSET_NEW_FEATURE[2024].Eureka}`,
                                target: '_self',
                                title: 'Eureka',
                            }, {
                                permission: 'SuperSet',
                                href: `/#/ProductDataStatistics/features/2024/${SUPERSET_NEW_FEATURE[2024].Workspace}`,
                                target: '_self',
                                title: 'Workspace',
                            }, {
                                permission: 'SuperSet',
                                href: `/#/ProductDataStatistics/features/2024/${SUPERSET_NEW_FEATURE[2024].BOP}`,
                                target: '_self',
                                title: 'BOP',
                            }],
                    },
                    {
                        permission: 'SuperSet',
                        route: `${PRODUCT_DATA_STATISTICS.FEATURE}2023`,
                        title: 'backoffice.nav.dataStatistics.feature2023',
                        icon: 'CompassIcon',
                        enable: ENABLE_SUPERSET_NEW_FEATURE,
                        children: [{
                                permission: 'SuperSet',
                                href: `/#/ProductDataStatistics/features/2023/${SUPERSET_NEW_FEATURE[2023].Analytics}`,
                                target: '_self',
                                title: 'Analytics',
                            }, {
                                permission: 'SuperSet',
                                href: `/#/ProductDataStatistics/features/2023/${SUPERSET_NEW_FEATURE[2023].Eureka}`,
                                target: '_self',
                                title: 'Eureka',
                            }, {
                                permission: 'SuperSet',
                                href: `/#/ProductDataStatistics/features/2023/${SUPERSET_NEW_FEATURE[2023].Workspace}`,
                                target: '_self',
                                title: 'Workspace',
                            }, {
                                permission: 'SuperSet',
                                href: `/#/ProductDataStatistics/features/2023/${SUPERSET_NEW_FEATURE[2023].BOP}`,
                                target: '_self',
                                title: 'BOP',
                            }],
                    }],
            }
        ];
    }
    else {
        // 如果是admin 的header 头
        commonHeader = [
            {
                permission: 'AdminPatsnapAccountList',
                title: 'backoffice.nav.admin.accounts',
                icon: 'UsersIcon',
                route: E_ROUTE_ADMIN.ACCOUNTS,
            },
            {
                permission: 'AdminRoleShow',
                title: 'backoffice.nav.admin.roles',
                icon: 'ServerIcon',
                route: E_ROUTE_ADMIN.ROLES,
            },
            {
                permission: 'AdminHistory',
                title: 'backoffice.nav.admin.history',
                faIcon: 'history',
                route: E_ROUTE_ADMIN.HISTORY,
            },
            {
                permission: 'AdminAudit',
                title: 'backoffice.nav.admin.audit',
                icon: 'CalendarIcon',
                route: E_ROUTE_ADMIN.AUDIT,
            },
            {
                permission: 'AdminCorsWhitelist',
                title: 'corsWhitelist.title',
                icon: 'ShieldIcon',
                route: E_ROUTE_ADMIN.CORS_WHITELIST,
            }
        ];
    }
    // 通过权限过滤路由配置
    commonHeader = removeBlockedMenu(commonHeader, $P);
    /* 路由点击标题跳转到第一个tab 通过 */
    commonHeader = map(commonHeader, item => {
        const children = first(item.children);
        if (children) {
            const route = get(children, 'route');
            const href = get(children, 'href');
            item = merge({}, item, {
                route,
                href,
            });
            return item;
        }
        return item;
    });
    if (layout === E_Layout.horizontal) {
        return commonHeader;
    }
    else {
        return [
            {
                header: 'CS管理',
            },
            ...commonHeader
        ];
    }
}
/**
 * 递归第一个菜单层级深度
 * 直到获取最内层的route
 * */
export function getEnableFirstRoute(menu) {
    const children = _.get(menu, '[0].children', []);
    if (children && children.length) {
        return getEnableFirstRoute(children);
    }
    return _.get(menu, '[0].route', '');
}
